<template>
  <div>
    <div id="update-customer-group" class="mt-6 vs-con-loading__container background-with-theme">
      <div v-if="groupList.length != 0">
        <!-- <vx-card class="mb-5 overflow-hidden md:p-0 p-5" v-for="(group, index) in groupList" :key="index">
            <template slot="no-body">
                <div class="item-details no-gutter p-6 flex align-center">
                    <div class="w-11/12">{{group.name}}</div>
                    <div class="1/12 ml-auto vs-component con-vs-checkbox vs-checkbox-primary vs-checkbox-default">
                        <input class="vs-checkbox--input" type="checkbox" v-model="checkBox" :id="group.id" :value="group.id" @change="onChange" @click="check(group)">
                        <span class="checkbox_x vs-checkbox" style="border: 2px solid rgb(180, 180, 180);">
                          <span class="vs-checkbox--check"><i class="vs-icon notranslate icon-scale vs-checkbox--icon  material-icons null">check</i></span>
                        </span>
                    </div>
                </div>
            </template>
        </vx-card> -->
        <vx-card class="mb-5 overflow-hidden shadow-md" v-for="(group, index) in groupList" :key="index" :class="{'is-selected': group.isInCurrentCustomer}">
          <div class="vs-component con-vs-checkbox vs-checkbox-primary vs-checkbox-default p-6">
            <span class="con-slot-label">
              <div class="title ml-auto">{{group.name}}</div>
            </span>
            <input type="checkbox" class="vs-checkbox--input" v-model="checkBox" :id="group.id" :value="group.id" @change="onChange" @click="check(group)">
            <span class="checkbox_x vs-checkbox ml-auto">
              <span class="vs-checkbox--check"><i class="vs-icon notranslate icon-scale vs-checkbox--icon  material-icons null">check</i></span>
            </span>

          </div>
        </vx-card>
      </div>
      <div class="text-center" v-else>No data available</div>
    </div>

    <div v-if="groupData._meta.pageCount">
       <custom-pagination class="custom-pagination mt-6" :totalPages="parseInt(groupData._meta.pageCount)"
        :currentPage="currentPage" @pageChanged="changePage" :key="page_key"></custom-pagination>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'vs-update-customer-group',
        props: {
            activeCustomer: {
                type: Object,
                required: true
            },
            checkoutFilter: {
              type: Object,
              default: null
            }
        },
        data() {
            const obj = {
                id: this.activeCustomer.id
            }
            this.$store.dispatch("customerList/GET_A_CUSTOMER", obj);
            return {
                checkBox: [],
                currentPage: 1,
                itemsPerpage: 10,
                isOpenLoading: false,
                page_key: 0
            }
        },
        computed: {
            customerInfo() {
              return this.$store.getters["customerList/customerInfo"];
            },
            groupList() {
              return this.$store.getters["customerList/groupList"];
            },
            groupData() {
              return this.$store.getters["customerList/groupData"];
            }
        },
        methods: {
          openLoadingInDiv(){
            this.$vs.loading({
              container: '#update-customer-group',
              scale: 0.8
            })
            if (this.loadTime) {
              clearTimeout(this.loadTime);
              this.loadTime = null;
            }
            this.isOpenLoading = true;
            this.loadTime = setTimeout( ()=> {
              if(this.isOpenLoading) {
                this.closeLoading();
                // this.$vs.notify({
                //   title:'Notification',
                //   text: 'Update customer group failed',
                //   color:'danger',
                //   position:'top-right'})
                this.$vs.dialog({
                  color: 'danger',
                  title: 'Notification',
                  text: 'Update customer group failed',
                  acceptText: 'OK'
                })
              }
            }, 10000);
            // setTimeout( ()=> {
            //   this.$vs.loading.close('#staff-list > .con-vs-loading')
            // }, 500);

          },
          closeLoading() {
            this.$vs.loading.close('#update-customer-group > .con-vs-loading');
            this.isOpenLoading = false;
          },
          onChange(){
            this.openLoadingInDiv();
            const obj = {
              customer_id: this.activeCustomer.id,
              group_ids: String(this.checkBox),
              page : this.currentPage,
              "per-page": this.itemsPerpage,
              checkout_filter: this.checkoutFilter
            }
            this.$store.dispatch("customerList/UPDATE_CUSTOMER_GROUP",obj).then(() => {
              this.closeLoading();
              this.$vs.notify({
                title:'Notification',
                text:'Update Group For Customer Success',
                color:'success',
                position:'top-right'});
            })
          },
          check: function(e) {
            if (e.checked) {
              console.log(e.value)
            }
          },
          selectId(e) {
            this.selectedId = e.id
            this.checkBox.push(this.selectedId)
          },
            // changeStatus(group) {
            //     this.$store.dispatch('customerList/CHANGE_GROUP_STATUS_IN_A_CUSTOMER', group);
            // },
          changePage(currentPage){
            const obj = {
                page: currentPage,
                "per-page": this.itemsPerpage,
            }
            // this.action_type = 'Get list'
            this.openLoadingInDiv();
            this.$store.dispatch("customerList/GET_GROUP_LIST", obj).then(() => {
              this.$store.dispatch('customerList/UPDATE_CUSTOMER_GROUP_STATUS');
              this.closeLoading();
              this.page_key++;
              this.currentPage = currentPage;
            })
          },
        },
        created() {
            const obj = {
              page : this.currentPage,
             'per-page': this.itemsPerpage
            }
            this.$store.dispatch("customerList/GET_GROUP_LIST",obj).then(() => {
              let groupList = this.$store.getters["customerList/customerInfo"];
              for(let i=0 ;i<groupList.groups.length;i++){
                this.checkBox.push(groupList.groups[i].group_id)
              }
            })
        }
    }
</script>
